
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Splash() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/auth');
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#1565C0] via-[#1976D2] to-[#FBC02D] flex flex-col items-center justify-center relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 right-10 w-32 h-32 bg-white rounded-full"></div>
        <div className="absolute bottom-32 left-8 w-24 h-24 bg-white rounded-full"></div>
        <div className="absolute top-1/2 left-1/4 w-16 h-16 bg-white rounded-full"></div>
      </div>

      {/* Logo Container */}
      <div className="relative z-10 flex flex-col items-center">
        {/* Logo Icon */}
        <div className="w-24 h-24 bg-white rounded-full flex items-center justify-center mb-6 shadow-lg animate-pulse">
          <i className="ri-briefcase-fill text-4xl text-[#1565C0]"></i>
        </div>

        {/* App Name */}
        <h1 className="text-3xl font-bold text-white mb-2 animate-fade-in" style={{ fontFamily: 'Pacifico, serif' }}>
          FutureStaff
        </h1>

        {/* Tagline */}
        <p className="text-white/90 text-lg text-center px-8 mb-8">
          منصة إدارة موظفي الفعاليات والمشاريع
        </p>

        {/* Loading Animation */}
        <div className="flex space-x-2">
          <div className="w-3 h-3 bg-white rounded-full animate-bounce"></div>
          <div className="w-3 h-3 bg-white rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
          <div className="w-3 h-3 bg-white rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
        </div>
      </div>

      {/* Bottom Text */}
      <div className="absolute bottom-8 text-center">
        <p className="text-white/80 text-sm">
          مرحباً بك في مستقبل إدارة الموارد البشرية
        </p>
      </div>
    </div>
  );
}
